import {Pipe, PipeTransform} from '@angular/core';
import {EventDetailsType} from '../../domain/event/event';
import {ReservationDetailDto} from '../../domain/reservation/reservationDto';

@Pipe({
    name: 'asReservationDetail'
})
export class ReservationDetailPipe implements PipeTransform {

    constructor() {
    }

    transform(event: EventDetailsType): ReservationDetailDto {
        return event as ReservationDetailDto;
    }
}
